<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
    <div class="bg-bkk-25 flex flex-col rounded-lg p-2">
      <div
        v-if="
          challengeType ===
          CompetitiveChallengeType.COMPETITIVE_CHALLENGE_TYPE_STEPS
        "
        class="mb-4"
      >
        <WalkIcon class="w-6 h-6" />
      </div>
      <div v-else class="mb-4">
        <BikeIcon class="w-6 h-6" />
      </div>
      <div>
        {{ formatProgressValue(totalProgress) }}
      </div>
      <div
        v-if="
          challengeType ===
          CompetitiveChallengeType.COMPETITIVE_CHALLENGE_TYPE_STEPS
        "
      >
        {{
          t("comp.challenge.started.tab.ranking.progress.label", {
            s: t("challenges.tab.filter.steps"),
          })
        }}
      </div>
      <div v-else>
        {{
          t("comp.challenge.started.tab.ranking.progress.label", {
            s: t("bicycle.semantics"),
          })
        }}
      </div>
    </div>
    <div class="bg-bkk-25 flex flex-col rounded-lg p-2">
      <div class="mb-4"><CO2Icon /></div>
      <div>
        {{ formatCompetitiveChallengeCo2(totalCo2Saving) }}
      </div>
      <div>
        {{ t("comp.challenge.started.tab.ranking.card.co2.label") }}
      </div>
    </div>
  </div>
  <HeadlineElement>
    <div
      v-if="rankingSortType === RankingSortType.RANKING_SORT_TOTAL"
      v-html="t('comp.challenge.teams.ranking.total')"
    ></div>
    <div v-else v-html="t('comp.challenge.teams.ranking.average')"></div>
  </HeadlineElement>

  <div v-for="team in teams" :key="team.id">
    <TeamListElement
      :team="team"
      :team-challenge-type="challengeType"
      :ranking-sort-type="rankingSortType"
    />
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { CompetitiveChallengeType } from "../../../enum/v2/competitive-challenge-type";
import { RankingSortType } from "../../../enum/v2/ranking-sort-type";
import WalkIcon from "../icon/WalkIcon.vue";
import BikeIcon from "../icon/BikeIcon.vue";
import CO2Icon from "../icon/CO2Icon.vue";
import HeadlineElement from "../layout/HeadlineElement.vue";
import TeamListElement from "./TeamListElement.vue";
import { CompetitiveChallengeTeamDto } from "../../../dto/competitive-challenge-team.dto";
import {
  formatCompetitiveChallengeCo2,
  formatCompetitiveChallengeProgress,
} from "../../../plugins/NumberFormat";
const { t } = useI18n();

const props = defineProps({
  teams: {
    type: Array as PropType<CompetitiveChallengeTeamDto[]>,
    required: true,
  },
  challengeType: {
    type: String as PropType<CompetitiveChallengeType>,
    required: true,
  },
  rankingSortType: {
    type: String as PropType<RankingSortType>,
    required: true,
  },
  progress: {
    type: Number,
    required: true,
  },
  co2progress: {
    type: Number,
    required: true,
  },
});

const totalProgress = props.teams.reduce(
  (sum, team) => sum + (team.totalProgress ?? 0),
  0
);
const totalCo2Saving = props.teams.reduce(
  (sum, team) => sum + (team.totalCo2Saving ?? 0),
  0
);

function formatProgressValue(value: number): string {
  return formatCompetitiveChallengeProgress(value, props.challengeType, {
    roundUp: true,
  });
}
</script>
